import { createContext, useContext } from 'react';
import { CurationLabel } from 'hooks/useCuration';

interface ICuration {
  getLabels(key: string): Set<CurationLabel>;
  isCurationTarget(key: string): boolean;
  isMinDuration(key: string): boolean;
  isMinPrice(key: string): boolean;
  isNonstopMinPrice(key: string): boolean;
  isTopBooking(key: string): boolean;
  isTopClick(key: string): boolean;
}

const CurationContext = createContext<ICuration>({
  getLabels: () => new Set(),
  isCurationTarget: () => false,
  isMinDuration: () => false,
  isMinPrice: () => false,
  isNonstopMinPrice: () => false,
  isTopBooking: () => false,
  isTopClick: () => false,
});

const useCurationContext = () => useContext(CurationContext);

export { CurationContext, useCurationContext };
